import { IComponentOptions, IController } from 'angular';
import './gmc-local-spinner.component.scss';

export class GmcLocalSpinnerController implements IController {

}

export const GmcLocalSpinnerComponent: IComponentOptions = {
  controller: GmcLocalSpinnerController,
  template: require('./gmc-local-spinner.component.html'),
  bindings: {}
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-local-spinner/gmc-local-spinner.component.ts